let map
const markers = []
let resizeTimer
let defaultIcon
let activeIcon
let activeId = null

const hasTourLogin = () => {
	try {
		return window.TOURLOGIN === true
	} catch (e) {
		return false
	}
}

const canAutoLoadWithoutHint = () => hasTourLogin()

const todayKey = () => new Date().toDateString()

function createCircleIcon(size, fill, stroke, strokeWidth) {
	const radius = (size - strokeWidth) / 2
	const svg = `
		<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
			<circle cx="${size / 2}" cy="${size / 2}" r="${radius}" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
		</svg>`
	return {
		url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
		scaledSize: new google.maps.Size(size, size),
		anchor: new google.maps.Point(size / 2, size / 2)
	}
}

function scrollListToItem($item) {
	const $list = $('.list')
	if (!$list.length || !$item.length) return
	const listTop = $list.offset().top
	const itemTop = $item.offset().top
	$list.stop().animate({
		scrollTop: $list.scrollTop() + itemTop - listTop
	}, 400)
}

function setActiveById(id, scrollIntoView) {
	if (!id) return
	if (activeId === id) {
		if (scrollIntoView) {
			const existing = markers.find(entry => entry.id === id)
			if (existing) scrollListToItem(existing.$item)
		}
		return
	}
	activeId = id
	markers.forEach(entry => {
		const isActive = entry.id === id
		entry.$item.toggleClass('is-active', isActive)
		if (entry.marker && defaultIcon && activeIcon) {
			entry.marker.setIcon(isActive ? activeIcon : defaultIcon)
		}
	})
	if (scrollIntoView) {
		const targetEntry = markers.find(entry => entry.id === id)
		if (targetEntry) scrollListToItem(targetEntry.$item)
	}
}

function resetActiveStates() {
	activeId = null
	markers.forEach(entry => {
		entry.$item.removeClass('is-active')
		if (entry.marker && defaultIcon) {
			entry.marker.setIcon(defaultIcon)
		}
		if (entry.infoWindow) {
			entry.infoWindow.close()
		}
	})
}

function adjustMapBounds(visibleMarkers) {
	if (!visibleMarkers || visibleMarkers.length === 0) return
	const bounds = new google.maps.LatLngBounds()
	visibleMarkers.forEach(entry => {
		if (entry.marker && entry.marker.getPosition) {
			bounds.extend(entry.marker.getPosition())
		}
	})
	map.fitBounds(bounds)
}

function getVisibleMarkerEntries() {
	return markers.filter(entry => entry.marker && entry.marker.getMap())
}

function applyYearFilter() {
	const $years = $('.years .year')
	if (!$years.length) return

	const $specificActiveYears = $years.filter('.is-active').not('[data-year="all"]')
	const hasSpecificYears = $specificActiveYears.length > 0
	const activeYears = []

	if (hasSpecificYears) {
		$specificActiveYears.each(function () {
			const y = $(this).data('year')
			if (y != null) activeYears.push(String(y))
		})
	}

	let visibleEntries = []

	if (!hasSpecificYears) {
		markers.forEach(entry => {
			entry.$item.show()
			if (entry.marker) entry.marker.setMap(map)
			visibleEntries.push(entry)
		})
	} else {
		markers.forEach(entry => {
			const match = activeYears.indexOf(entry.year) !== -1
			entry.$item.toggle(match)
			if (entry.marker) entry.marker.setMap(match ? map : null)
			if (match) visibleEntries.push(entry)
		})
	}

	if (visibleEntries.length === 0) {
		return
	}

	if (activeId !== null) {
		const stillVisible = visibleEntries.find(entry => entry.id === activeId)
		if (!stillVisible) {
			activeId = null
		}
	}

	if (activeId !== null) {
		setActiveById(activeId, false)
	}

	adjustMapBounds(visibleEntries)
}

function initYearFilter() {
	const $years = $('.years .year')
	if (!$years.length) return

	$years.off('click.mapFilter').on('click.mapFilter', function () {
		const $this = $(this)
		const year = $this.data('year')

		resetActiveStates()

		if (year === 'all') {
			$years.removeClass('is-active')
			$this.addClass('is-active')
		} else {
			$this.toggleClass('is-active')
			const $all = $years.filter('[data-year="all"]')
			$all.removeClass('is-active')
			const hasSpecific = $years.filter('.is-active').not('[data-year="all"]').length > 0
			if (!hasSpecific) {
				$all.addClass('is-active')
			}
		}

		applyYearFilter()
	})

	const $all = $years.filter('[data-year="all"]')
	if ($all.length) {
		$years.removeClass('is-active')
		$all.addClass('is-active')
		resetActiveStates()
		applyYearFilter()
	}
}

function initMap() {
	const options = {
		center: { lat: 51.3397, lng: 12.3731 },
		zoom: 14,
		styles: tourstyles,
		draggable: true,
		scrollwheel: false,
		scaleControl: true,
		panControl: false,
		zoomControl: true,
		mapTypeControl: false,
		streetViewControl: false,
		fullscreenControl: false
	}

	map = new google.maps.Map(document.getElementById('googlemap'), options)

	defaultIcon = createCircleIcon(20, '#3b00d2', '#ffffff', 3)
	activeIcon = createCircleIcon(26, '#3b00d2', '#ffffff', 3)
	markers.length = 0
	activeId = null

	const $list = $('.list')

	$('.list .call').each(function () {
		const $item = $(this)
		const latlong = $item.data('latlong')
		const id = $item.data('id')
		const title = $item.find('.title').text()
		const yearData = $item.data('year')
		const year = yearData != null ? String(yearData) : null
		if (!latlong || !id) return

		const parts = latlong.toString().split(',')
		const lat = parseFloat(parts[0])
		const lng = parseFloat(parts[1])
		if (isNaN(lat) || isNaN(lng)) return

		const marker = new google.maps.Marker({
			position: { lat: lat, lng: lng },
			map: map,
			title: title,
			icon: defaultIcon
		})

		const infoWindow = new google.maps.InfoWindow({
			content: title,
			disableAutoPan: true
		})

		const entry = { id: id, marker: marker, infoWindow: infoWindow, $item: $item, year: year }
		markers.push(entry)

		marker.addListener('mouseover', function () {
			infoWindow.open(map, marker)
			setActiveById(id, true)
		})

		marker.addListener('mouseout', function () {
			infoWindow.close()
		})

		marker.addListener('click', function () {
			scrollListToItem($item)
		})
	})

	$list.off('mouseenter.mapHover').on('mouseenter.mapHover', '.call', function () {
		const id = $(this).data('id')
		setActiveById(id, false)
		const entry = markers.find(e => e.id === id)
		if (!entry || !entry.marker || !map) return
		if (entry.marker.getMap && !entry.marker.getMap()) return
		const pos = entry.marker.getPosition && entry.marker.getPosition()
		const bounds = map.getBounds && map.getBounds()
		if (!pos) return
		if (bounds && bounds.contains && bounds.contains(pos)) return
		if (map.panTo) {
			map.panTo(pos)
		} else if (map.setCenter) {
			map.setCenter(pos)
		}
	})

	if ($('.years .year').length) {
		initYearFilter()
	} else if (markers.length) {
		adjustMapBounds(markers)
	}
}

$(window).on('resize', function () {
	clearTimeout(resizeTimer)
	resizeTimer = setTimeout(function () {
		if (!map || markers.length === 0) return
		const visibleEntries = getVisibleMarkerEntries()
		if (visibleEntries.length > 0) {
			adjustMapBounds(visibleEntries)
		}
	}, 300)
})

$('.hint').on('click', function () {
	if (canAutoLoadWithoutHint()) return
	localStorage.setItem('mapHintDismissed', todayKey())
	$(this).remove()
	if (typeof loadMap === 'function') loadMap()
})

$(document).ready(function () {
	if (typeof loadMap !== 'function') return

	if (canAutoLoadWithoutHint()) {
		$('.hint').remove()
		loadMap()
		return
	}

	if (localStorage.getItem('mapHintDismissed') === todayKey()) {
		$('.hint').remove()
		loadMap()
	}
})
